var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.finance.bought
    ? _c("div", { staticClass: "container hold" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("\n        保有フアンド\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-title" }, [
            _vm._v("\n            匿名組合契約型\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title1" }, [
            _vm._v(
              "\n            インドネシア・マイクロファイナンス第1号（匿名組合契約型）\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title2" }, [
            _vm._v("\n            目標利回り：７％／年\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title2" }, [
            _vm._v("\n            運用期間：１８０日\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title2" }, [
            _vm._v(
              "\n            ファンド名：インドネシア・マイクロファイナンス第1号（匿名組合契約型）\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pdf-wrap" },
            _vm._l(_vm.pdfList, function (item, idx) {
              return _c(
                "div",
                {
                  key: idx,
                  staticClass: "pdf-item",
                  on: {
                    click: function ($event) {
                      return _vm.handleRead(item)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "pdf-icon",
                    attrs: { src: require("./img/pdf.svg"), alt: "" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "pdf-title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.pdfDisplayNameMap[item]) +
                        ".pdf\n                "
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "sub-info" }, [
            _vm._v(
              "\n            (※202X年8月31日時点の金額であリ将来変動します)\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sub-info" }, [
            _vm._v("\n            (※2出資金3,000万円(@0.0096))\n        "),
          ]),
        ]),
      ])
    : _c("i-empty")
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info" }, [
      _c("div", { staticClass: "info-item" }, [
        _c("div", { staticClass: "info-title" }, [
          _vm._v("\n                    324,600万ルピア(※1)\n                "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-desc" }, [
          _vm._v(
            "\n                    贷付残高(202X年8月31日)\n                "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("div", { staticClass: "info-title" }, [
          _vm._v("\n                    312,500万ルピア(※2)\n                "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-desc" }, [
          _vm._v(
            "\n                    事業開始時(202X年5月31日)\n                "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }